import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlListaObrasParadas = '/service/materiais/obras/'

class ConsultaListaObrasParadasService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    consultar(filtro) {
        let data = {
            exercicioParalisacao: filtro.exercicioParalisacao ? filtro.exercicioParalisacao : '',
        }
        return this.conex.post(urlListaObrasParadas + 'consultaListaObrasParadas/', JSON.stringify(data))
    }
}

export default ConsultaListaObrasParadasService
